// extracted by mini-css-extract-plugin
export default {"button":"intersection_button_button__v1W8Q"};